import { format } from 'date-fns'

/**
 * 日付をHH:mm:ssの形式に変換する
 * @param date 日付
 * @returns HH:mm:ssの形式の文字列
 * @example
 * dateToTimeString(new Date()) // "15:30:45"
 */
export const dateToTimeString = (date: Date): string => {
    return format(date, 'HH:mm:ss')
}
